import { useMaterialModel } from 'api';

import { useEvidenceAiSessionDetails } from '../../hooks/useEvidenceAiSessionDetails/useEvidenceAiSessionDetails';
import { EvidenceAiDetails } from '../EvidenceAiDetails/EvidenceAiDetails';

export const EvidenceAiSessionDetails = ({
  date,
  parentContentTypeId,
  parentId,
  uploadedById,
  siteMaterialId,
}: {
  date: string;
  parentContentTypeId: number;
  parentId: number;
  uploadedById: number | null;
  siteMaterialId: number;
}) => {
  const { petComposition, photoEvidence, evidenceList, stats, aluminiumComposition } = useEvidenceAiSessionDetails({
    date,
    parentContentTypeId: parentContentTypeId,
    parentId: parentId,
    uploadedById: uploadedById,
  });
  const model = useMaterialModel(String(siteMaterialId ?? ''), false);

  return (
    <EvidenceAiDetails
      photoEvidence={photoEvidence}
      evidenceList={evidenceList}
      stats={stats}
      model={model ?? 'alu'}
      aluminiumComposition={aluminiumComposition}
      petComposition={petComposition}
    />
  );
};
